import { render } from "./QiangJianPage.vue?vue&type=template&id=584fde08&scoped=true"
import script from "./QiangJianPage.vue?vue&type=script&lang=js"
export * from "./QiangJianPage.vue?vue&type=script&lang=js"

import "./QiangJianPage.vue?vue&type=style&index=0&id=584fde08&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-584fde08"]])

export default __exports__